
const agency = (state = {
  representation: undefined,
  represented: undefined,
  agencies: undefined
}, action) => {
  switch (action.type) {
    case 'AGENCY_PAGE':
    console.log('from reducer',action)
      return {
        ...state,
        // representation: action.payload
        // ...action.papyload
        representation: action.payload[0].representation_requests,
        represented: action.payload[1].representation_request,
        agencyInfo: action.payload[2].agencies.length ? action.payload[2].agencies[0] : undefined
      }
    case 'REPRESENTATION_LIST': 
      // console.log('reducer-agency', action.payload)
      return {
        ...state,
        representation: action.payload.representation_requests
      }
    case 'REPRESENTED_ARTIST':
      return {
        ...state,
        represented: action.payload.representation_request,
        token: action.payload.tokenisApproved
      }
    case 'AGENCY_ARTIST_DENY':
    case 'AGENCY_ARTIST_APPROVE':
        // console.log('reducer-agency2', state, action)
        // if (action.artist_id) {
        //   let successAction = action.type === 'AGENCY_ARTIST_APPROVE' ? 'approved' : 'deny'
        //   return {
        //   ...state,
        //     representation: state.representation.map( rep => 
        //       (rep.id == action.artist_id) 
        //       ? {...rep, successAction: successAction }
        //       : rep
        //     )
        //   }

        // }

      return {
        ...state,
        isApproved: action.payload
      }
    case 'AGENCY_DETAILS':
      return {
        ...state,
        agencies: action.payload.agency
      }
    case 'AGENCY_LOGIN':
      console.log('AGENCY_LOGIN', action.payload)
      return {
        agent: action.payload.agency
      }
    default:
      return state;
  }
};

export default agency


// WEBPACK FOOTER //
// ./src/reducers/agency.js